import { Project, Route } from '../types';

export function migrateProject(project: Project): Project {
  // Only log if there are actual changes to be made
  const needsMigration = !project.type || 
    project.network.routes.some(route => !route.distanceCalculation);

  if (needsMigration) {
    console.debug('Migrating project:', {
      id: project.id,
      changes: {
        type: !project.type,
        routes: project.network.routes.filter(r => !r.distanceCalculation).length
      }
    });
  }

  // Add distance calculation method and automatic distance to existing routes that don't have them
  const updatedRoutes = project.network.routes.map(route => ({
    ...route,
    distanceCalculation: route.distanceCalculation || 'manual' as const,
    automaticDistance: route.automaticDistance
  }));

  // Create migrated project, ensuring type safety
  const migratedProject = {
    ...project,
    type: (project.type === 'example' || project.type === 'user') ? project.type : 'user' as const,
    network: {
      ...project.network,
      routes: updatedRoutes
    }
  };

  return migratedProject;
} 